import { render, staticRenderFns } from "./ProductComponentMain.vue?vue&type=template&id=30ba4bf0&"
import script from "./ProductComponentMain.vue?vue&type=script&lang=ts&"
export * from "./ProductComponentMain.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports